export default __webpack_public_path__ + "static/media/Type E main cover.900690fd.jpg";